(function(){
  function getCookie(name){var m=document.cookie.match(new RegExp('(?:^|; )'+name+'=([^;]*)'));return m?decodeURIComponent(m[1]):null}
  function setCookie(name,value){document.cookie=name+'='+encodeURIComponent(value)+'; path=/; max-age='+(30*24*3600)+'; SameSite=Lax'}
  function saveRHCookie(){
    var params=new URLSearchParams(window.location.search);
    var mwr=params.get('mwr')||getCookie('rh_mwr');
    var bonus=params.get('bonus')||'';
    if(!bonus){try{bonus=localStorage.getItem('zl_bonus')||''}catch(e){}}
    if(!bonus) bonus=getCookie('rh_bonus')||'';
    if(params.get('bonus')){setCookie('rh_bonus',params.get('bonus'));try{localStorage.setItem('zl_bonus',params.get('bonus'))}catch(e){}}
    if(!mwr) return Promise.resolve();
    setCookie('rh_mwr',mwr);try{localStorage.setItem('zl_mwr',mwr)}catch(e){}
    var attrs={mwr:mwr}; if(bonus) attrs.bonus=bonus;
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attrs})}).catch(function(){});
  }
  function patchCartDrawer(){
    if(window.__zlCartPatched) return; window.__zlCartPatched=true;
    if(window.routes) window.routes.cart_add_url='/cart/add.js';
    var originalFetch=window.fetch;
    window.fetch=function(url,options){
      return originalFetch.apply(this,arguments).then(function(response){
        // if(typeof url==='string'&&(url.indexOf('/cart/change')>-1||url.indexOf('/cart/update')>-1||url.indexOf('/cart/add')>-1)){
        //   response.clone().json().then(refreshCartDrawer).catch(function(){});
        // }
        if(typeof url==='string'&&(url.indexOf('/cart/change')>-1||url.indexOf('/cart/update')>-1)){
          response.clone().json().then(refreshCartDrawer).catch(function(){});
        }
        return response;
      });
    };
  }
  // function refreshCartDrawer(cart){
  //   document.querySelectorAll('.cart-count-bubble,[data-cart-count],.cart-icon-bubble span').forEach(function(el){
  //     if(!cart||cart.item_count===0){el.style.display='none'}else{el.style.display='';el.textContent=cart.item_count}
  //   });
  //   fetch('/?sections=cart-drawer,cart-icon-bubble').then(function(r){return r.json()}).then(function(sections){
  //     if(sections['cart-drawer']){
  //       var drawer=document.querySelector('cart-drawer');
  //       if(drawer){var tmp=document.createElement('div');tmp.innerHTML=sections['cart-drawer'];
  //         ['.cart-drawer__body','.drawer__footer','.drawer__header'].forEach(function(sel){
  //           var n=tmp.querySelector(sel),o=drawer.querySelector(sel); if(n&&o) o.innerHTML=n.innerHTML;
  //         });
  //         if(typeof drawer.open==='function') drawer.open(); else drawer.classList.add('active','animate');
  //       }
  //     }
  //     if(sections['cart-icon-bubble']){var icon=document.getElementById('cart-icon-bubble');var t=document.createElement('div');t.innerHTML=sections['cart-icon-bubble'];var nb=t.querySelector('#cart-icon-bubble');if(icon&&nb)icon.innerHTML=nb.innerHTML;}
  //   }).catch(function(){});
  // }

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-count-bubble,[data-cart-count],.cart-icon-bubble span').forEach(function(el) {
        if (!cart || cart.item_count === 0) {
          el.style.display = 'none';
        } else {
          el.style.display = '';
          el.textContent = cart.item_count;
        }
      });

      return fetch('/?sections=cart-drawer,cart-icon-bubble');
    })
    .then(function(r) { return r.json(); })
    .then(function(sections) {
      if (sections['cart-drawer']) {
        var tmp = document.createElement('div');
        tmp.innerHTML = sections['cart-drawer'];

        var drawer = document.querySelector('cart-drawer');
        var newDrawer = tmp.querySelector('cart-drawer');

        if (drawer && newDrawer) {
          drawer.outerHTML = newDrawer.outerHTML;
          drawer = document.querySelector('cart-drawer');
        }

        setTimeout(function() {
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else if (drawer) {
            drawer.classList.add('active', 'animate');
          }
        }, 100);
      }

      if (sections['cart-icon-bubble']) {
        var icon = document.getElementById('cart-icon-bubble');
        var t = document.createElement('div');
        t.innerHTML = sections['cart-icon-bubble'];
        var nb = t.querySelector('#cart-icon-bubble');
        if (icon && nb) icon.innerHTML = nb.innerHTML;
      }
    })
    .catch(console.error);
}
function initPacks() {
  const packs = document.querySelectorAll('.zl-pack');
  const form = document.querySelector('form[action*="/cart/add"]');

  packs.forEach(pack => {
    pack.addEventListener('click', function() {
      packs.forEach(p => p.classList.remove('is-active'));
      this.classList.add('is-active');

      const radio = this.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
        
        // On récupère le texte du nombre de participations (le <small>)
        const ticketText = this.querySelector('small').innerText;

        // On crée ou met à jour un input caché pour envoyer l'info à Shopify
        let propInput = form.querySelector('input[name="properties[Participations]"]');
        if (!propInput) {
          propInput = document.createElement('input');
          propInput.type = 'hidden';
          propInput.name = 'properties[Participations]';
          form.appendChild(propInput);
        }
        propInput.value = ticketText;

        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
}

  function updateSelectedVariant(element, variantId) {
    // 1. Visuel : on bouge la classe active
    document.querySelectorAll('.zl-pack').forEach(el => el.classList.remove('is-active'));
    element.classList.add('is-active');

    // 2. On met à jour l'input caché du formulaire Shopify
    const formInput = document.querySelector('input[name="id"]');
    if (formInput) {
        formInput.value = variantId;
    }

    // 3. Optionnel : Mettre à jour le prix total affiché si besoin
    // Le thème Shrine s'en occupe généralement tout seul s'il détecte le changement d'ID
}

document.addEventListener('DOMContentLoaded', function() {
  const packs = document.querySelectorAll('.zl-pack');
  
  packs.forEach(pack => {
    pack.addEventListener('click', function() {
      // 1. Mise à jour visuelle (Bordure orange)
      packs.forEach(p => p.classList.remove('is-active'));
      this.classList.add('is-active');

      // 2. Sélection de la variante pour le formulaire
      const variantId = this.getAttribute('data-variant-id');
      const radioInput = this.querySelector('input[type="radio"]');
      if (radioInput) radioInput.checked = true;

      // 3. Mise à jour du formulaire natif (Compatibilité Shrine Pro)
      // On cherche l'input "id" dans le formulaire d'achat
      const mainInput = document.querySelector('input[name="id"]');
      if (mainInput) {
        mainInput.value = variantId;
        // On déclenche l'événement 'change' pour que le thème Shrine mette à jour les prix
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
});

// function patchAddToCartForm() {
//   document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
//     if (form.dataset.zlAjaxPatched) return;
//     form.dataset.zlAjaxPatched = 'true';

//     form.addEventListener('submit', function(e) {
//       e.preventDefault();

//       const formData = new FormData(form);

//       fetch('/cart/add.js', {
//         method: 'POST',
//         body: formData,
//         headers: { Accept: 'application/json' }
//       })
//       .then(function() {
//         setTimeout(function() {
//           refreshCartDrawer();
//         }, 300);
//       })
//       .catch(console.error);
//     });
//   });
// }

function patchAddToCartForm() {
  const BONUS_VARIANT_ID = 53957624103239; // remplace par l’ID de la variante bonus

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
    if (form.dataset.zlAjaxPatched) return;
    form.dataset.zlAjaxPatched = 'true';

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const formData = new FormData(form);
      const bonusCheckbox = document.querySelector('#zl-bonus-participations');

      if (bonusCheckbox && bonusCheckbox.checked) {
        const mainVariantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: mainVariantId,
                quantity: quantity
              },
              {
                id: BONUS_VARIANT_ID,
                quantity: 1
              }
            ]
          })
        })
        .then(function() {
          setTimeout(function() {
            refreshCartDrawer();
          }, 300);
        })
        .catch(console.error);

      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        })
        .then(function() {
          setTimeout(function() {
            refreshCartDrawer();
          }, 300);
        })
        .catch(console.error);
      }
    });
  });
}

  function initFloat(){
    var params=new URLSearchParams(window.location.search),mwr=params.get('mwr');
    if(mwr){setCookie('rh_mwr',mwr);try{localStorage.setItem('zl_mwr',mwr)}catch(e){}}
    try{mwr=mwr||localStorage.getItem('zl_mwr')}catch(e){}
    mwr=mwr||getCookie('rh_mwr');
    var floatEl=document.getElementById('zfloat-h'),innerEl=document.getElementById('zfloat-h-inner'),iconEl=document.getElementById('zfloat-h-icon'),labelEl=document.getElementById('zfloat-h-label');
    if(!floatEl||!labelEl||floatEl.hasAttribute('hidden')) return;
    if(!mwr) return;
    floatEl.style.display='block';
    var bonus=params.get('bonus')||''; if(!bonus){try{bonus=localStorage.getItem('zl_bonus')||''}catch(e){}} bonus=bonus||getCookie('rh_bonus')||'';
    var nb=(bonus.toLowerCase().indexOf('duel')>-1||bonus.toLowerCase().indexOf('match')>-1)?2:1;
    labelEl.textContent='+'+nb+' OFFERT'+(nb>1?'S':'');
    floatEl.addEventListener('click',function(){document.getElementById('domitius-concours')?.scrollIntoView({behavior:'smooth'});});
    var header=document.querySelector('header,.header,#header,[class*="header"]');
    if(header&&'IntersectionObserver'in window){new IntersectionObserver(function(entries){entries.forEach(function(entry){floatEl.classList.toggle('visible',!entry.isIntersecting)})},{threshold:0}).observe(header)}
    else{window.addEventListener('scroll',function(){floatEl.classList.toggle('visible',window.scrollY>300)},{passive:true})}
    setInterval(function(){if(!innerEl||!iconEl)return;innerEl.classList.add('tap');var orig=iconEl.textContent;iconEl.textContent='CLIC';iconEl.style.fontSize='9px';iconEl.style.letterSpacing='1px';setTimeout(function(){innerEl.classList.remove('tap');iconEl.textContent=orig;iconEl.style.fontSize='';iconEl.style.letterSpacing=''},600)},5000);
  }
  document.addEventListener('DOMContentLoaded',function(){patchCartDrawer();patchAddToCartForm();saveRHCookie();setTimeout(saveRHCookie,2000);initPacks();initFloat();document.addEventListener('click',function(e){if(e.target.closest('[name="add"],.btn-atc,[data-action="add-to-cart"],button[type="submit"]')) saveRHCookie();});});
})();


const endDate = new Date("2026-08-31T23:59:59").getTime();

function updateCountdown() {
  const now = new Date().getTime();
  const distance = endDate - now;

  if (distance <= 0) return;

  document.getElementById("days").textContent = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, "0");
  document.getElementById("hours").textContent = String(Math.floor((distance / (1000 * 60 * 60)) % 24)).padStart(2, "0");
  document.getElementById("minutes").textContent = String(Math.floor((distance / (1000 * 60)) % 60)).padStart(2, "0");
  document.getElementById("seconds").textContent = String(Math.floor((distance / 1000) % 60)).padStart(2, "0");
}

updateCountdown();
setInterval(updateCountdown, 1000);


(function () {
  'use strict';

  var ANCHOR   = '#shopify-section-template--30011267875146__main';
  var FULL_URL = '/products/bparticipation-jeu-iloveaurelien' + ANCHOR;

  function ouvrir(overlayId, boxId) {
    var overlay = document.getElementById(overlayId);
    var box     = document.getElementById(boxId);
    if (!overlay || !box) return;
    overlay.style.display = 'block';
    box.style.display     = 'block';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('zcpg-pop--on');
        box.classList.add('zcpg-pop--on');
      });
    });
    document.body.style.overflow = 'hidden';
  }

  function fermer(overlayId, boxId) {
    var overlay = document.getElementById(overlayId);
    var box     = document.getElementById(boxId);
    if (!overlay || !box) return;
    overlay.classList.remove('zcpg-pop--on');
    box.classList.remove('zcpg-pop--on');
    setTimeout(function () {
      overlay.style.display = 'none';
      box.style.display     = 'none';
    }, 280);
    document.body.style.overflow = '';
  }

  function scrollVersPacks() {
    var target = document.querySelector(ANCHOR);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.location.href = FULL_URL;
    }
  }

  function init() {

    /* VOITURE — image */
    var imgCar = document.getElementById('zcpg-img-car');
    if (imgCar) {
      imgCar.addEventListener('click', function () { ouvrir('zcpg-overlay-car', 'zcpg-box-car'); });
      imgCar.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') ouvrir('zcpg-overlay-car', 'zcpg-box-car');
      });
    }

    /* VOITURE — fermer */
    var closeCar = document.getElementById('zcpg-close-car');
    if (closeCar) closeCar.addEventListener('click', function () { fermer('zcpg-overlay-car', 'zcpg-box-car'); });

    var overlayCar = document.getElementById('zcpg-overlay-car');
    if (overlayCar) overlayCar.addEventListener('click', function () { fermer('zcpg-overlay-car', 'zcpg-box-car'); });

    /* VOITURE — CTA */
    var ctaCar = document.getElementById('zcpg-cta-car');
    if (ctaCar) {
      ctaCar.addEventListener('click', function () {
        fermer('zcpg-overlay-car', 'zcpg-box-car');
        setTimeout(scrollVersPacks, 200);
      });
    }

    /* VOYAGE — image */
    var imgTravel = document.getElementById('zcpg-img-travel');
    if (imgTravel) {
      imgTravel.addEventListener('click', function () { ouvrir('zcpg-overlay-travel', 'zcpg-box-travel'); });
      imgTravel.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') ouvrir('zcpg-overlay-travel', 'zcpg-box-travel');
      });
    }

    /* VOYAGE — fermer */
    var closeTravel = document.getElementById('zcpg-close-travel');
    if (closeTravel) closeTravel.addEventListener('click', function () { fermer('zcpg-overlay-travel', 'zcpg-box-travel'); });

    var overlayTravel = document.getElementById('zcpg-overlay-travel');
    if (overlayTravel) overlayTravel.addEventListener('click', function () { fermer('zcpg-overlay-travel', 'zcpg-box-travel'); });

    /* VOYAGE — CTA */
    var ctaTravel = document.getElementById('zcpg-cta-travel');
    if (ctaTravel) {
      ctaTravel.addEventListener('click', function () {
        fermer('zcpg-overlay-travel', 'zcpg-box-travel');
        setTimeout(scrollVersPacks, 200);
      });
    }

    /* Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      fermer('zcpg-overlay-car',    'zcpg-box-car');
      fermer('zcpg-overlay-travel', 'zcpg-box-travel');
    });
  }

  /* Attendre que le DOM soit complètement prêt */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

document.querySelectorAll('.zl-thumb').forEach((thumb) => {
  thumb.addEventListener('click', function () {
    const main = document.getElementById('zl-main-image');
    main.src = this.dataset.image;
  });
});